import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  Select,
  Button,
  VStack,
  useToast,
  Text,
} from "@chakra-ui/react";
import { validateResumeFile } from "../utils/fileValidation";
import { RESUME_SOURCE_OPTIONS } from "../constants/statuses";

const ResumeUploadModal = ({ isOpen, onClose, onUpload, isLoading }) => {
  const toast = useToast();
  const [file, setFile] = useState(null);
  const [source, setSource] = useState("manual_upload");
  const [candidateId, setCandidateId] = useState("");
  const [sourceReference, setSourceReference] = useState("");
  const [tags, setTags] = useState("");

  const handleSubmit = async () => {
    const validation = validateResumeFile(file);
    if (!validation.valid) {
      toast({ title: validation.message, status: "warning", duration: 2500 });
      return;
    }

    const formData = new FormData();
    formData.append("resume", file);
    formData.append("source", source);
    if (candidateId.trim()) {
      formData.append("candidateId", candidateId.trim());
    }
    if (sourceReference.trim()) {
      formData.append("sourceReference", sourceReference.trim());
    }
    formData.append("tags", tags);

    await onUpload?.(formData);
    setFile(null);
    setCandidateId("");
    setSourceReference("");
    setTags("");
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Upload Resume</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="stretch">
            <FormControl>
              <FormLabel>Resume File</FormLabel>
              <Input
                type="file"
                onChange={(e) => setFile(e.target.files?.[0] || null)}
              />
              <Text mt={1} fontSize="xs" color="gray.500">
                Allowed: PDF, DOC, DOCX. Max 20 MB.
              </Text>
            </FormControl>
            <FormControl>
              <FormLabel>Source</FormLabel>
              <Select
                value={source}
                onChange={(e) => setSource(e.target.value)}
              >
                {RESUME_SOURCE_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Select>
            </FormControl>
            <FormControl>
              <FormLabel>Candidate ID (Optional)</FormLabel>
              <Input
                value={candidateId}
                onChange={(e) => setCandidateId(e.target.value)}
                placeholder="MongoDB candidateId"
              />
            </FormControl>
            <FormControl>
              <FormLabel>Source Reference (Optional)</FormLabel>
              <Input
                value={sourceReference}
                onChange={(e) => setSourceReference(e.target.value)}
                placeholder="Email/portal reference id"
              />
            </FormControl>
            <FormControl>
              <FormLabel>Tags</FormLabel>
              <Input
                value={tags}
                onChange={(e) => setTags(e.target.value)}
                placeholder="comma,separated,tags"
              />
            </FormControl>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button mr={3} variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme="blue"
            onClick={handleSubmit}
            isLoading={isLoading}
          >
            Upload
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ResumeUploadModal;
